import { DELETE, GET, PATCH, POST } from '@/shared/api/requests';

import type {
  CreateSafetyIssueInput,
  MoveSafetyPinInput,
  SafetyIssue,
  SafetyIssueFilters,
  SafetyIssueStatus,
  SafetyLayout,
  SafetyPhotoContext,
  SafetyTrade,
  UpdateSafetyIssueInput,
} from './types';

const BASE = '/safety/issues';

export const getSafetyIssues = async (
  projectId: number,
  filters: SafetyIssueFilters = {}
): Promise<SafetyIssue[]> => {
  const params = new URLSearchParams({ project_id: String(projectId) });
  if (filters.layoutId) params.set('layout_id', String(filters.layoutId));
  if (filters.status) params.set('status', filters.status);
  if (filters.hotspotId) params.set('hotspot_id', String(filters.hotspotId));
  const response = await GET(`${BASE}/?${params}`);
  const data = response.data;
  return Array.isArray(data) ? data : ((data as { results?: SafetyIssue[] }).results ?? []);
};

export const createSafetyIssue = async (input: CreateSafetyIssueInput): Promise<SafetyIssue> =>
  (await POST(`${BASE}/`, input)).data as SafetyIssue;

export const updateSafetyIssueStatus = async (
  issueId: string,
  status: SafetyIssueStatus
): Promise<SafetyIssue> => (await PATCH(`${BASE}/${issueId}/`, { status })).data as SafetyIssue;

export const updateSafetyIssue = async (
  issueId: string,
  input: UpdateSafetyIssueInput
): Promise<SafetyIssue> => (await PATCH(`${BASE}/${issueId}/`, input)).data as SafetyIssue;

export const moveSafetyPin = async (input: MoveSafetyPinInput): Promise<SafetyIssue[]> =>
  (await POST(`${BASE}/move-pin/`, input)).data as SafetyIssue[];

export const deleteSafetyIssue = async (issueId: string): Promise<void> => {
  await DELETE(`${BASE}/${issueId}/`);
};

export const getSafetyLayouts = async (projectId: number): Promise<SafetyLayout[]> =>
  (await GET(`${BASE}/layouts/?project_id=${projectId}`)).data as SafetyLayout[];

export const getSafetyTrades = async (projectId: number): Promise<SafetyTrade[]> =>
  (await GET(`${BASE}/trades/?project_id=${projectId}`)).data as SafetyTrade[];

export const getSafetyPhotoContext = async (
  projectId: number,
  photoId: number
): Promise<SafetyPhotoContext> =>
  (await GET(`${BASE}/photo-context/?project_id=${projectId}&photo_id=${photoId}`))
    .data as SafetyPhotoContext;
